/**
 * Componente Input reutilizable para formularios.
 * 
 * @param {string} label - nombre del campo.
 * @param {string} value - Valor del campo.
 * @param {function} onChange - Función para manejar cambios.
 * @param {string} name - Nombre del campo.
 * @param {string} type - Tipo de input ("text", "select", "textarea", etc.).
 * @param {string} placeholder - Texto de marcador de posición.
 * @param {Array} options - Opciones para el select (debe ser un array de objetos con `{ value, label }`).
 * @param {string} show - Define si el campo se muestra o se oculta (ej. "block", "hidden").
 * @param {number} rows - Cantidad de filas (solo para `textarea`).
 * @param {boolean} carga - Muestra un `Spinner` si es `true`.
 * @param {boolean} readonly - Indica si el campo es de solo lectura.
 */
import Spinner from "../common/Spinner"
const Input = ({
  label,
  value,
  onChange,
  name,
  type = "text",
  placeholder = "",
  options = [],
  show = "block",
  rows = 4,
  carga = false,
  readonly = false
}) => {
  return (
    <div className={`${show} mb-4`}>
      {/* Label con Spinner opcional */}
      <div className="flex items-center">
        <label htmlFor={name} className="block text-gray-700">{label}</label>
        {carga && <Spinner size={20} />}
      </div>

      {/* Renderizado condicional según el tipo de input */}
      {type === "select" ? (
        <select
          id={name}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="border rounded p-2 w-full border-gray-300"
          disabled={readonly}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === "textarea" ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          className="border rounded p-2 w-full border-gray-300 resize-none"
          readOnly={readonly}
        />
      ) : (
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="border rounded p-2 w-full border-gray-300"
          readOnly={readonly}
        />
      )}
    </div>
  )
}

export default Input
